import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-summary-card',
  imports: [],
  templateUrl: './summary-card.component.html',
  styleUrl: './summary-card.component.scss',
})
export class SummaryCardComponent {
  /** Título/label superior do card */
  @Input() label = '';

  /** Valor em destaque exibido abaixo do label */
  @Input() value: string | null | undefined = '';
}
